/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractLitigationCaseTransformations from "./abstractLitigationCaseTransformations";

const abstractAdministrativeLitigationCaseTransformations: FormTransformations = {
  dateFields: [
    ...abstractLitigationCaseTransformations.dateFields!,
    { path: "administrativeProceedingsLetterSentDate", type: "date" },
    { path: "administrativeProceedingsLetterSentDeadline", type: "date" },
    { path: "administrativeDecisionReceivedDate", type: "date" },
    { path: "authorityResponseToObjectionDate", type: "date" },
  ],
  numberFields: abstractLitigationCaseTransformations.numberFields,
  timeFields: abstractLitigationCaseTransformations.timeFields,
  floatFields: abstractLitigationCaseTransformations.floatFields,
  ibanFields: abstractLitigationCaseTransformations.ibanFields,
};

export default abstractAdministrativeLitigationCaseTransformations;
